// 화면 UI 커스텀 설정 API 클라이언트 — /api/v2/me/ui-prefs
//
// 로그인 계정마다 화면 단위 배치·표시 설정(칼럼 순서·숨김, 필터 노출 등)을 jsonb 통째로
// 읽고 쓴다. 값의 모양은 화면마다 달라 여기서는 제네릭으로만 다루고, 해석·정규화는
// 각 화면 훅(useCrmCustomerLayout 등)이 담당한다. 인증·에러 처리는 공통 _client.

import { authJson } from "./_client";

const API = `${import.meta.env.VITE_API_BASE_URL ?? ""}/api/v2/me`;

/** 내 화면 설정 1건. 저장된 적 없으면 null — 화면은 코드 기본 배치로 그린다. */
export async function fetchUiPref<T>(key: string): Promise<T | null> {
  const res = await authJson<{ config: T | null }>(
    `${API}/ui-prefs/${encodeURIComponent(key)}`,
  );
  return res.config ?? null;
}

/** 화면 설정 저장(upsert). config 객체를 통째로 보관한다. */
export async function saveUiPref<T extends object>(key: string, config: T): Promise<void> {
  await authJson(`${API}/ui-prefs/${encodeURIComponent(key)}`, {
    method: "PUT",
    body: JSON.stringify(config),
  });
}

/** 화면 설정 초기화 — 저장 줄을 지워 코드 기본 배치로 되돌린다. */
export async function deleteUiPref(key: string): Promise<void> {
  await authJson(`${API}/ui-prefs/${encodeURIComponent(key)}`, { method: "DELETE" });
}
